import { Box, Grid, Typography, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  ACTION_LEFT_DRAWER,
  ACTION_OPEN_TOOLBAR,
  ACTION_RESET,
  ACTION_RIGHT_DRAWER,
  ACTION_SET_APPBAR_JSX,
  ACTION_SET_TOOLBAR_JSX,
} from '../../component/MainUIFrame/constants';
import { useMainFrameDispatch } from '../../component/MainUIFrame/MainFrame';
import EHRToolbar from '../ehr/contents/toolbarContent';
import _ from 'lodash';
import axios from 'axios';
import Invoiceeditmode from './invoicePage';
import { DataGrid } from '@mui/x-data-grid';
// import { makeStyles } from '@material-ui/core/styles';
import { makeStyles } from '@mui/styles';
import InvoicePage from './invoicePage';
import { getDateOnly } from '../../config/common';
import { ehrAPIBaseService } from '../../http-common';

const toolBarContentJson = [
  {
    icon: 'note_add',
    name: 'createInvoice',
    title: 'Create Invoice',
    link: '',
  },
  {
    icon: 'folder_open',
    name: '',
    title: '',
    link: '',
  },
  {
    icon: 'print',
    name: '',
    title: '',
    link: '',
  },
  {
    icon: 'save',
    name: 'Save',
    title: 'save',
    click: '',
  },
  {
    icon: 'send',
    name: 'sendClaims',
    title: 'Send Claims',
    click: '',
  },
  {
    icon: 'edit',
    name: '',
    title: '',
    link: '',
  },
  {
    icon: 'undo',
    name: '',
    title: '',
    link: '',
  },
  {
    icon: 'redo',
    name: '',
    title: '',
    link: '',
  },
  {
    icon: 'content_cut',
    name: '',
    title: '',
    link: '',
  },
  {
    icon: 'content_copy',
    name: '',
    title: '',
    link: '',
  },
  {
    icon: 'content_paste',
    name: '',
    title: '',
    link: '',
  },
  {
    icon: 'delete',
    name: '',
    title: '',
    link: '',
  },
  {
    icon: 'file_download',
    name: '',
    title: '',
    link: '',
  },
  {
    icon: 'push_pin',
    name: '',
    title: '',
    link: '',
  },
  {
    icon: 'bookmark_border',
    name: '',
    title: '',
    link: '',
  },
  {
    icon: 'filter_alt',
    name: '',
    title: '',
    link: '',
  },
  {
    icon: 'settings',
    name: '',
    title: '',
    link: '',
  },
  {
    icon: 'help',
    name: '',
    title: 'Patient View',
    link: '',
  },
];

const columnData = [
  {
    field: 'id',
    headerName: 'Id',
    flex: 1,
    //hide: true,
  },
  {
    field: 'patient',
    headerName: 'Invoice Reference',
    flex: 1,
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
  },
  {
    field: 'invoiceCreatedDate',
    headerName: 'Invoice Created Date',
    flex: 1,
  },
];

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer':
      {
        display: 'none',
      },
  },
}));

const InvoiceList = ({ patientId }) => {
  const dispatch = useMainFrameDispatch();
  const classes = useStyles();
  const [listView, setListView] = useState(true);
  const [isDisabled, setDisabled] = useState(true);
  const [selectionModel, setSelectionModel] = useState();
  const [invoiceObject, setInvoiceObject] = useState({});
  const [rowData, setRowData] = useState([]);
  const [chargeItems, setChargeItems] = useState([]);
  const [isAddbtnDisabled, setAddbtnDisabled] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [currentSelectedRow, setCurrentSelectedRow] = useState({});

  const AppBarJsx = () => {
    return (
      <Grid container>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography
            sx={{
              color: 'appBarIcon',
            }}
            variant="h5"
          >
            {'Invoice'}
          </Typography>
        </Box>
      </Grid>
    );
  };

  useEffect(() => {
    dispatch({ type: ACTION_LEFT_DRAWER });
    dispatch({ type: ACTION_RIGHT_DRAWER });
    dispatch({ type: ACTION_OPEN_TOOLBAR });
    dispatch({ type: ACTION_SET_APPBAR_JSX, payload: <AppBarJsx /> });
    dispatch({
      type: ACTION_SET_TOOLBAR_JSX,
      payload: <EHRToolbar options={toolBarContentJson} />,
    });

    return () => {
      dispatch({
        type: ACTION_RESET,
      });
    };
  }, []);

  const getInvoiceList = async () => {
    try {
      const response = await ehrAPIBaseService.get(
        `fhir/search/?resourceType=Invoice`
      );
      console.log('response of invoice ', response);
      let tempRows = [];
      for (const item of response?.data?.entry) {
        let singleRow = {};
        singleRow.id = _.get(item, 'resource.id', '');
        singleRow.status = _.get(item, 'resource.status', '');
        singleRow.invoiceCreatedDate = getDateOnly(
          _.get(item, 'resource.date', '')
        );
        singleRow.patient = _.get(item, 'resource.subject.reference', '');
        singleRow.totalPriceComponent = _.get(
          item,
          'resource.totalPriceComponent[0].amount.value'
        );
        tempRows.push(singleRow);
      }
      console.log('temp rows :', tempRows);
      setRowData(tempRows);
      console.log('items of charge ', rowData);
    } catch (e) {
      console.error(`EHR->ehrGetAllInvoices ${e}`);
    }
  };

  useEffect(() => {
    getInvoiceList();
  }, [listView]);

  return (
    <>
      <Grid container>
        {listView ? (
          <Grid container>
            <Grid
              container
              sx={{
                padding: 1,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Grid
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: 2,
                }}
                item
                xs={12}
              >
                <Button
                  onClick={() => {
                    setListView(false);
                    setEdit(true);
                  }}
                  name="updateInvoice"
                  variant="outlined"
                  disabled={isDisabled}
                >
                  View
                </Button>
                <Button
                  onClick={() => {
                    setInvoiceObject({});
                    setEdit(false);
                    setListView(false);
                  }}
                  name="createInvoice"
                  variant="outlined"
                  disabled={isAddbtnDisabled}
                >
                  Create
                </Button>
              </Grid>
            </Grid>
            <Grid item xs={12} className="overflow pm-0">
              <DataGrid
                className={classes.root}
                autoHeight
                rows={rowData}
                columns={columnData}
                pageSize={10}
                rowsPerPageOptions={[10]}
                checkboxSelection
                //disableSelectionOnClick
                selectionModel={selectionModel}
                onSelectionModelChange={ids => {
                  const selectionSet = new Set(selectionModel);
                  const result = ids.filter(s => !selectionSet.has(s));
                  setSelectionModel(result);
                  const selectedIDs = new Set(ids);
                  const selectedRowData = ids.map(id =>
                    rowData.find(row => row.id === id)
                  );
                  let sRow =
                    selectedRowData.length > 0 &&
                    selectedRowData[selectedRowData.length - 1];
                  console.log(sRow);
                  setCurrentSelectedRow(sRow);
                  if (sRow) {
                    setInvoiceObject(sRow);
                    setDisabled(false);
                    setAddbtnDisabled(true);
                  } else {
                    setDisabled(true);
                    setAddbtnDisabled(false);
                  }
                }}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
            item
            xs={12}
          >
            <InvoicePage
              patientId={patientId}
              listView={listView}
              isEdit={isEdit}
              invoiceObject={invoiceObject}
              setListView={setListView}
              setDisabled={setDisabled}
              setSelectionModel={setSelectionModel}
              chargeItems={chargeItems}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default InvoiceList;
